export const initialStepTwoSensors = [
  {
    type: '',
    sensorEui: '',
    sensorKey: '',
    isNew: true,
  },
];

export const initialStepTwoZones = [
  {
    name: '',
    plantType: '',
    plantName: '',
    soilType: '',
    sensors: [],
  },
];

export const initialStepTwoValues = [
  {
    name: '',
    file: undefined,
    zones: initialStepTwoZones,
    sensors: [],
  },
];

export const zoneHeight = 219;
export const gap = 16;

export const detailLineMarginLeft = 27;
export const zoneLineMarginLeft = 97;

export const detailMobileLineMarginLeft = 13;
export const zoneMobileLineMarginLeft = 45;
